import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OutboundCallList, OutboundCall } from '@modules/calls/Domain/call.model';
import { GET_OUTBOUND_CALLS_LIST, GET_OUTBOUND_CALL_BY_ID } from '@modules/calls/Domain/outboundCall.config';

@Injectable({
  providedIn: 'root',
})
export class OutboundCallService {
  constructor(private apollo: Apollo) {}

  getOutboundCalls(criteria: any): Observable<OutboundCallList> {
    return this.apollo
      .query<{ outboundCallList: OutboundCallList }>({
        query: GET_OUTBOUND_CALLS_LIST,
        variables: {
          criteria,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res.data.outboundCallList));
  }

  getOutboundCallById(id: string): Observable<OutboundCall> {
    return this.apollo
      .query<{ outboundCall: OutboundCall }>({
        query: GET_OUTBOUND_CALL_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res.data.outboundCall));
  }
}
